'use strict';

var ServiceLegCabinTransformerFactory = function ServiceLegCabinTransformerFactory(DataTransformer) {
  function ServiceLegCabinTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'cabin';
    this.targetType = 'bid-price-chart';
    this.priority = 1;
  }
  ServiceLegCabinTransformer.prototype = Object.create(DataTransformer.prototype);
  ServiceLegCabinTransformer.constructor = ServiceLegCabinTransformer;
  ServiceLegCabinTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ServiceLegCabinTransformer.prototype.isCacheable = function () {
    return true;
  };
  ServiceLegCabinTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  ServiceLegCabinTransformer.prototype.transform = function (data) {
    var input = data.domain.legCabins || data.domain.results;
    var result = [];
    for (var i = 0, length = input.length; i < length; i++) {
      var entry = input[i];
      result.push({
        cabinCode: entry.cabinCode,
        leg: entry.leg,
        bidPrices: entry.bidPrices,
        seatsAvailableModel: entry.seatsAvailableModel
      });
    }
    return result;
  };
  return ServiceLegCabinTransformer;
};
ServiceLegCabinTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ServiceLegCabinTransformerFactory;